import React from "react";
import { DndContext, closestCenter, useSensor, useSensors, PointerSensor, TouchSensor } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { ProgressHeaderWithPopup } from "../components/progressHeaderWithPopup";
import { HeadLogo } from "../components/headLogo";
import { CheckMoreButtons } from "../components/checkMoreButtons";
import { GameIntroHeader } from "../components/gameIntroHeader";
import {LocationImageDisplay} from "../components/locationImageDisplay";
import { ModeIndication } from "../components/modeIndication";

function SortableItem({ id, content, correct, showCheck }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id,
    transition: {
      duration: 150,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: 'grab',
    touchAction: 'none',
  };

  const className = `sortable-item ${
    showCheck ? (correct ? "correct" : "incorrect") : ""
  }`;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={className}
      {...attributes}
      {...listeners}
    >
      <DragIndicatorIcon className="sortable-item-icon" />
      <span>{content}</span>
    </div>
  );
}

function TimelineScrambleView({
  mode,
  title,
  items,
  currentStep,
  onCheck,
  isChecked,
  correctOrder,
  onDragEnd,
  onComplete,
  imageKey
}) {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 0,
        tolerance: 0,
      },
    })
  );

  return (
    <div className="timeline-layout">
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={currentStep} title={title}  />
      <ModeIndication mode={mode} />
      <div className="timeline-scramble-wrapper">
      <div className="timeline-content">
        <GameIntroHeader
          title="Timeline Scramble"
          description={"Put events in order"}
        />

        <div className="timelinescramble-gameInfo">
          <div className="timeline-h2">Earlier</div>

            <DndContext 
              sensors={sensors}
              collisionDetection={closestCenter} 
              onDragEnd={onDragEnd}
            >
            <SortableContext
              items={items.map((i) => i.id)}
              strategy={verticalListSortingStrategy}
            >
              {items.map((item, index) => (
                <SortableItem
                  key={item.id}
                  id={item.id}
                  content={item.text}
                  correct={item.id === correctOrder[index]}
                  showCheck={isChecked}
                />
              ))}
            </SortableContext>
          </DndContext>

          <div className="timeline-h2">Recent</div>
        </div>

        {!isChecked ? (
          <div className="timelinescramble-checkmore">
            <button className="checkmore-btn" onClick={onCheck}>
              Check
            </button>
          </div>
        ) : (
          <CheckMoreButtons onNext={onComplete} />
        )}
        </div>
          <LocationImageDisplay imageKey={imageKey} />
      </div>
    
    </div>
  );
}

export { TimelineScrambleView };
